import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';
import { CountryPrefixEnum } from 'Jsx/CheckoutV4/types';

import { getBrasilPhoneMask, getPeruPhoneMask } from './formatPhoneNumber';

const getPhoneNumber = ({
  country,
  event,
}: {
  country?: string;
  event: React.ChangeEvent<HTMLInputElement>;
}): {
  phoneNumber: string;
  isPhoneNumberValid: boolean;
  phoneNumberErrorMessage: string;
  phoneNumberDidigts: number;
} => {
  let { value } = event.target;

  if (country === CountryPrefixEnum.BRASIL) {
    return getBrasilPhoneMask(event);
  }

  if (country === CountryPrefixEnum.PERU) {
    return getPeruPhoneMask(event);
  }

  value = value.replace(/[a-zA-Z]/g, '');
  return {
    phoneNumber: value,
    isPhoneNumberValid: !!(value && value.length > 9),
    phoneNumberErrorMessage: '',
    phoneNumberDidigts: 10,
  };
};

export default getPhoneNumber;

export const validatePhoneNumber = ({
  country,
  event,
}: {
  country?: string;
  event: React.ChangeEvent<HTMLInputElement>;
}): {
  phoneNumber: string;
  isPhoneNumberValid: boolean;
  phoneNumberErrorMessage: string;
  phoneNumberDidigts: number;
} => {
  const {
    phoneNumber,
    isPhoneNumberValid,
    phoneNumberErrorMessage,
    phoneNumberDidigts,
  } = getPhoneNumber({ country, event });
  let errorMessage = phoneNumberErrorMessage;

  if (!phoneNumber) {
    errorMessage = I18N_STRINGS.REQUIRED_PHONE_NUMBER;
  } else if (phoneNumber.length < phoneNumberDidigts) {
    errorMessage = I18N_STRINGS.INCOMPLETE_PHONE_NUMBER;
  } else if (!isPhoneNumberValid) {
    errorMessage = I18N_STRINGS.INVALID_PHONE_NUMBER;
  }

  return {
    phoneNumber,
    isPhoneNumberValid,
    phoneNumberErrorMessage: errorMessage,
    phoneNumberDidigts,
  };
};
